<template>
  <div class="dialog-expert-add">
    <expert-info v-if="loadForm" ref="addExpertForm" :dialog="true" :info="expertInfo" :readonly="readonly"></expert-info>
  </div>
</template>

<script>
// 专家编辑
import ExpertInfo from '../../customPage/expertManage/expertInfoAdd'
export default {
  name: 'expertAdd',
  components: {ExpertInfo},
  props: {
    query: ''
  },
  data () {
    return {
      expertInfo: {
        id: null,
        name: ''
      },
      defaultExpert: {
        id: null,
        name: ''
      },
      loadForm: false,
      readonly: false
    }
  },
  created () {
    const _self = this;
    if (_self.query) {
      _self.expertInfo.id = _self.query.split('&')[0];
      _self.readonly = _self.query.split('&')[1] === 'readonly';
      _self.fetchExpertInfo();
    } else {
      _self.loadForm = true;
    }
  },
  methods: {
    fetchExpertInfo () {
      this.fetch('/exp/expInfo/info/' + this.expertInfo.id).then(res => {
        this.expertInfo = res.data;
        this.defaultExpert = JSON.parse(JSON.stringify(res.data));
        this.loadForm = true;
      });
    },
    /**
     * 框架弹窗确认时被调用，必须方法
     * @returns {Promise<any>}
     */
    dialogComfirm () {
      const _self = this;
      _self.expertInfo = _self.$refs['addExpertForm'].expertInfo;
      return new Promise((resolve, reject) => {
        // 调用子组件的表单验证方法
        _self.$refs['addExpertForm'].validate().then(valid => {
          if (valid) {
            // 获取子组件中的数据
            let param = Object.compare(_self.defaultExpert, _self.expertInfo);
            // 判断原数据id是否存在，即判断是新增还是修改专家
            if (_self.defaultExpert.id) {
              if (Object.keys(param).length === 0) {
                resolve();
                return;
              }
              // 修改专家
              param.id = _self.defaultExpert.id;
              _self.post('/exp/expInfo/saveOrUpdate', param).then(res => {
                resolve(res);
                _self.$Message.success('修改成功');
              }).catch(error => {
                reject(error);
              });
            } else {
              // 新增专家
              param = _self.expertInfo;
              delete param.id;
              _self.post('/exp/expInfo/saveOrUpdate', param).then(res => {
                resolve(res.data);
                _self.$Message.success('新增成功');
              }).catch(error => {
                reject(error);
              });
            }
          } else {
            reject(new Error());
          }
        })
      });
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/expertAdd.vue